export default __webpack_public_path__ + "static/media/LENS_CULINARIS_GDM_2.c3a62141.jpg";